import { ContainerModule, interfaces } from 'inversify'
import { DY_TYPES } from '@compliance/di/serviceIdentifiers'
import { IncidentViewModel } from '@compliance/modules/IncidentViewModel'

export const incidentViewModelModule = () =>
  new ContainerModule((bind: interfaces.Bind) => {
    bind<IncidentViewModel>(DY_TYPES.IncidentViewModel).to(IncidentViewModel)
  })
